module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-adaptimg-wrapper"
  }, [_c('img', {
    directives: [{
      name: "scroll-in-view-once",
      rawName: "v-scroll-in-view-once",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "img",
    style: (_vm.adjustSty),
    attrs: {
      "src": _vm.imgsrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-37bf2667"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/img/adaptImg.vue
// module id = 204
// module chunks = 1